import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { API, assetUrl } from "@/lib/api";
import PublicLayout from "@/components/PublicLayout";
import { useSeo } from "@/lib/seo";
import { UsersThree, SpinnerGap, PlayCircle } from "@phosphor-icons/react";

export default function PublicAlbum() {
  const { id } = useParams();
  const [d, setD] = useState(undefined);
  useEffect(() => { axios.get(`${API}/public/album/${id}`).then((r) => setD(r.data)).catch(() => setD(null)); }, [id]);
  useSeo({ title: d?.album ? `${d.album.title} — PhotoPulse` : "Shared album", description: d?.album?.description || "" });

  return (
    <PublicLayout>
      <div className="mx-auto max-w-6xl px-5 py-8">
        {d === undefined ? (
          <div className="grid h-[50vh] place-items-center"><SpinnerGap size={30} className="animate-spin text-[#F27A54]" /></div>
        ) : d === null ? (
          <div className="grid h-[50vh] place-items-center text-center">
            <UsersThree size={44} weight="thin" className="text-[#D9C9B3]" />
            <p className="mt-3 font-display font-bold">Album not found</p>
            <p className="text-sm text-[#787167]">It may be private or no longer exists.</p>
          </div>
        ) : (
          <>
            <div className="relative overflow-hidden rounded-3xl">
              <div className="h-40 sm:h-52">
                {d.album.cover_url ? <img src={assetUrl(d.album.cover_url)} alt="" className="h-full w-full object-cover" /> : <div className="brand-sunset h-full w-full" />}
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
              </div>
              <div className="absolute bottom-4 left-5">
                <p className="overline text-[10px] text-white/80">Shared album{d.album.owner_name ? ` · by ${d.album.owner_name}` : ""}</p>
                <h1 className="font-display text-3xl font-black text-white drop-shadow">{d.album.title}</h1>
              </div>
            </div>
            {d.photos.length === 0 ? (
              <p className="mt-10 text-center text-sm text-[#787167]">No photos in this album yet.</p>
            ) : (
              <div className="mt-6 columns-2 gap-4 md:columns-3 lg:columns-4 [&>*]:mb-4">
                {d.photos.map((p) => (
                  <Link key={p.id} to={`/p/${p.id}`} className="group relative block break-inside-avoid overflow-hidden rounded-2xl">
                    <img src={assetUrl(p.image_url)} alt="" loading="lazy" className="w-full object-cover transition-transform duration-500 group-hover:scale-105" />
                    {p.media_type === "video" && <PlayCircle size={40} weight="fill" className="absolute inset-0 m-auto text-white/90 drop-shadow" />}
                  </Link>
                ))}
              </div>
            )}
          </>
        )}
      </div>
    </PublicLayout>
  );
}
